import Chart from "chart.js/auto";
import $ from "jquery";

/**
 * Resizes all charts on window resize.
 */
export function InCoreChartResizeOnWindow(): void {
    const canvases = $("canvas[id]");
    if (canvases.length) {
        window.addEventListener("resize", function () {
            $.each(canvases, function (_index, canvas) {
                const chart = Chart.getChart(canvas.id);
                if (chart) {
                    chart.resize();
                }
            });
        });
    }
}

/**
 * Destroys a chart by its canvas ID.
 * @param {string} canvasId - The ID of the canvas element.
 */
export function InCoreChartDestroy(canvasId: string): void {
    const chart = Chart.getChart(canvasId);
    if (chart) {
        chart.destroy();
    }
}

/**
 * Retrieves a dataset for a chart via AJAX.
 * @param {string} url - The URL to fetch the dataset from.
 * @returns {Promise<any>} - A promise resolving to the dataset.
 */
export async function InCoreChartGetDataset(url: string): Promise<any> {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            success: function (result) {
                resolve(result);
            },
            error: function (xhr, status, error) {
                console.error("Error fetching chart dataset:", error);
                reject(null);
            }
        });
    });
}